import { FormattedMessage } from 'react-intl';
import Image from 'next/image';
import { StatefulButton } from '@openedx/paragon';
import { DEFAULT_ICONS_FOR_STATEFUL_BUTTON } from 'components/ui/atoms';
import { getIsCTADisabled, useAppSelector } from 'store';
import { PayPalForm } from './paypal-form';

export const PaymentMethodSelector = () => {
  const isCTADisabled = useAppSelector(getIsCTADisabled);

  return (
    <div className="mb-5">
      <h2 className="h5">
        <FormattedMessage
          id="checkout.payment.method.select.heading"
          defaultMessage="Select Payment Method"
          description="The heading for the payment method selection section"
        />
      </h2>
      <div className="d-flex flex-wrap">
        <StatefulButton
          className="payment-button"
          id="creditCardButton"
          variant="outline-primary"
          state={isCTADisabled ? 'disabled' : 'default'}
          disabledStates={['pending', 'disabled']}
          icons={DEFAULT_ICONS_FOR_STATEFUL_BUTTON}
          labels={{
            default: (
              <Image
                src="/images/accepted-card-logos.png"
                width={186}
                height={30}
                alt="Pay with Credit Card"
              />
            ),
          }}
        />
        <PayPalForm />
      </div>
    </div>
  );
};
